var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPresentation = function SvgPresentation(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 15,
    "data-width-24": 22,
    viewBox: "0 0 14.8 13.5",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M12.908.6H1.83C1.15.6.6 1.151.6 1.83V8.6c0 .68.55 1.23 1.23 1.23h11.077c.68 0 1.23-.55 1.23-1.23V1.83c0-.679-.55-1.23-1.23-1.23M4.526 12.908l2.462-3.077M8.219 9.831l2.461 3.077M7.37 6.446V4.6M9.831 6.446V3.985M4.908 6.446v-1.23"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPresentation);
export default ForwardRef;